export default __webpack_public_path__ + "static/media/12.SILOS.2c611581.jpg";